import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EServiceCategoryService {

  private apiUrl = environment.apiBaseUrl + '/api/eregistration/categories/';

  constructor(private http: HttpClient) { }

  getAll(langCode = ''): Observable<any> {
    return this.http.get(`${this.apiUrl}getAll?langCode=${langCode}`);
  }

  getById(id: number, langCode = ''): Observable<any> {
    return this.http.get(`${this.apiUrl}getById?id=${id}&langCode=${langCode}`);
  }

  create(request: any): Observable<any> {
    return this.http.post(`${this.apiUrl}create`, request);
  }

  update(id: number, request: any): Observable<any> {
    return this.http.put(`${this.apiUrl}update?id=${id}`, request);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}delete?id=${id}`);
  }
}
